"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LftIconButton_styles_1 = require("./LftIconButton.styles");
var LftIconButton = function (_a) {
    var _b, _c, _d, _e;
    var alt = _a.alt, _f = _a.ariaDisabled, ariaDisabled = _f === void 0 ? false : _f, ariaLabel = _a.ariaLabel, bgColor = _a.bgColor, _g = _a.brand, brand = _g === void 0 ? false : _g, dataElement = _a.dataElement, dataInfo = _a.dataInfo, dataTestId = _a.dataTestId, disabled = _a.disabled, icon = _a.icon, id = _a.id, _h = _a.size, size = _h === void 0 ? 'sm' : _h, _j = _a.tabIndex, tabIndex = _j === void 0 ? 0 : _j, _k = _a.type, type = _k === void 0 ? 'button' : _k, lftClick = _a.lftClick;
    var createElementFromHTMLString = function (htmlString) {
        var div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        return div.querySelector('svg');
    };
    var html = (_c = (_b = createElementFromHTMLString(icon)) === null || _b === void 0 ? void 0 : _b.outerHTML) !== null && _c !== void 0 ? _c : '';
    var _handleClick = function (e) {
        lftClick && lftClick(e);
    };
    if (dataElement) {
        if (dataElement.includes('_')) {
            if (typeof window !== 'undefined' && (((_d = window.location.href) === null || _d === void 0 ? void 0 : _d.indexOf("localhost")) > -1 || ((_e = window.location.href) === null || _e === void 0 ? void 0 : _e.indexOf("dev")) > -1)) {
                console.warn('Não é necessário mais colocar o prefixo no atributo dataElement');
            }
        }
        else {
            dataElement = "button_".concat(dataElement);
        }
    }
    return ((0, jsx_runtime_1.jsx)(LftIconButton_styles_1.IconButtonStyled, { "aria-disabled": ariaDisabled, "aria-label": ariaLabel, alt: alt, brand: brand, bgColor: bgColor, dangerouslySetInnerHTML: { __html: html }, "data-element": dataElement, "data-info": dataInfo, "data-lift": "lft-iconbutton", "data-testid": dataTestId ? dataTestId : id && id, disabled: disabled, id: id, size: size, tabIndex: tabIndex, type: type, onClick: _handleClick }));
};
exports.default = LftIconButton;
